import React, { ChangeEvent, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import CompanyName from '../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import Decision from '../../commonComponents/Decision';
import { DecisionType } from '../../../static/types/commonTypes/decisionType';
import LegalEntity from '../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import HeadOfficeAddress from '../../commonComponents/HeadOfficeAddress';
import { HeadOfficeAddressType } from '../../../static/types/commonTypes/headOfficeAddressType';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import DecisionWithQuality from '../../commonComponents/DecisionWithQuality';
import { formatObjectText } from '../../../utils/functions/formatObjectText';


interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}
const TransfertHorsDepartement: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,

}) => {


    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        headOfficeAddress, setHeadOfficeAddress,
        headOfficeAddressValidity, setHeadOfficeAddressValidity,
        headOfficeAddressChecked, setHeadOfficeAddressChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,


        decisionWithQualityAndEffectiveDate,
        setDecisionWithQualityAndEffectiveDate,
        decisionWithQualityAndEffectiveDateValidity,
        setDecisionWithQualityAndEffectiveDateValidity,
        decisionWithQualityAndEffectiveDateChecked,
        setDecisionWithQualityAndEffectiveDateChecked,

    } = useAppContext() as AppContextType
    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });
    const updateLegalEntity = (data: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...data });
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType]
    const updateHeadOfficeAddress = (data: Partial<HeadOfficeAddressType>) => setHeadOfficeAddress({ ...headOfficeAddress, ...data });
    const updateHeadOfficeAddressValidity = (isValid: boolean) => setHeadOfficeAddressValidity(isValid);
    const [submissive, setSubmissive] = useState<boolean>(false)
    const goToSupportPresse = () => updateActiveIndex(2);

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('raisonSociale')
        }
        else if (!decisionWithQualityAndEffectiveDateValidity) {
            setActiveTab('choisirDateDecision')
        }
        else if (!legalEntityValidity) {
            setActiveTab('laSociété')
        }
        else if (!headOfficeAddressValidity) {
            setActiveTab('nouvelleAdresseSiegeSocial')
        }

        return companyNameValidity && decisionWithQualityAndEffectiveDateValidity && legalEntityValidity && headOfficeAddressValidity

    };

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };
    
    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const handleSubmit = (e: ChangeEvent<HTMLFormElement>) => {

        e.preventDefault();

        console.log(validate())

        if (validate()) {
            const pluralSubjects = ["Les associés","Les actionnaires"];

            const verb = pluralSubjects.includes(decisionWithQualityAndEffectiveDate.decisionQuality) ? "ont" : "a";
            const decisionNature = decisionWithQualityAndEffectiveDate.decisionNature === "AG Extraordinaire"
                ? "l'AGE"
                : decisionWithQualityAndEffectiveDate.decisionNature === "AG Ordinaire"
                    ? "l'AGO"
                    : decisionWithQualityAndEffectiveDate.decisionNature === "AG Mixte"
                        ? "l'AG Mixte"
                        : decisionWithQualityAndEffectiveDate.decisionNature

            const decisionText = firstPartDecision.includes(decisionWithQualityAndEffectiveDate.decisionNature)
                ? `Aux termes de ${decisionNature} en date du ${decisionWithQualityAndEffectiveDate.decisionDate} ${decisionWithQualityAndEffectiveDate.decisionQuality} ${verb}`
                : `Le ${decisionWithQualityAndEffectiveDate.decisionDate}, ${decisionNature.toLowerCase()} ${verb}`



            const tempText = `${legalEntity.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €.
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.
${decisionText} décidé de transférer le siège social ${headOfficeAddress.address} ${headOfficeAddress.additionalAddress} ${headOfficeAddress.postalCode}  ${headOfficeAddress.city}, à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}.
Radiation au RCS  ${getCityWithPreposition(legalEntity.registrationOffice)} et réimmatriculation au RCS ${getCityWithPreposition(headOfficeAddress.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
            setSubmissive(true)
        }

        else setSubmissive(false)
    };

    const handleNext = () => {
        if (activeTab === "raisonSociale") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("raisonSociale"));
            }
        } else if (activeTab === "choisirDateDecision") {
            setDecisionWithQualityAndEffectiveDateChecked(true)
            if (decisionWithQualityAndEffectiveDateValidity) {
                switchTab(getNextTab("choisirDateDecision"));
            }
        } else if (activeTab === "laSociété") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("laSociété"));
            }
        } else if (activeTab === "nouvelleAdresseSiegeSocial") {
            setHeadOfficeAddressChecked(true)
            if (headOfficeAddressValidity) {
                setSubmissive(true);
            }
            else {
                setSubmissive(true)
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQualityAndEffectiveDate({ ...decisionWithQualityAndEffectiveDate, ...data });


    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'raisonSociale':
                return 'choisirDateDecision';
            case 'choisirDateDecision':
                return 'laSociété';
            case 'laSociété':
                return 'nouvelleAdresseSiegeSocial';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'nouvelleAdresseSiegeSocial':
                return 'laSociété';
            case 'laSociété':
                return 'choisirDateDecision';
            case 'choisirDateDecision':
                return 'raisonSociale';
            default:
                return currentTab;
        }
    };

    console.log('societyType reçu:', societyType);
    console.log('Type de societyType:', typeof societyType);
    console.log('societyTypeOptions final:', societyTypeOptions);


    const tabs = [
        {key: 'raisonSociale', label: 'Raison Sociale'},
        {key: 'choisirDateDecision', label: "Choisir l'organe et la date de la décision"},
        {key: 'laSociété', label: 'La société'},
        {key: 'nouvelleAdresseSiegeSocial', label: 'Nouvelle adresse du siège social'}
    ]
    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'raisonSociale' &&
                    <div>
                        <span>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                companyName={companyName}
                                checked={companyNameChecked}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                            <h6 className = 'text-bold' style={{backgroundColor: 'red', padding: '5px', color: 'white', fontSize: '13px'}}>
                                IMPORTANT : Dans le cas d'un transfert de siège hors département, ce formulaire génère l'annonce de départ, vous devez également publier l'annonce d'arrivée.
                            </h6>
                        </div>

                    </div>

                }

                {
                    activeTab === 'choisirDateDecision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQualityAndEffectiveDate}
                        draftFieldName = 'decisionWithQualityAndEffectiveDate'
                        checked={decisionWithQualityAndEffectiveDateChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityAndEffectiveDateValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'laSociété' &&
                    <div>
                        <span>
                            Pour la société, veuillez préciser l'adresse du siège social
                        </span>
                        <div className="tab-content">
                            <LegalEntity
                                companyName={companyName}
                                setCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                                checked={legalEntityChecked}
                                legalEntity={legalEntity}
                                changeLegalEntity={updateLegalEntity}
                                societyType={societyTypeOptions}
                                onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                                draftFieldName = 'legalEntity'
                            />
                        </div>

                    </div>

                }

                {
                    activeTab === "nouvelleAdresseSiegeSocial" &&
                    <HeadOfficeAddress
                        changeHeadOfficeAddress={updateHeadOfficeAddress}
                        checked={headOfficeAddressChecked}
                        headOfficeAddress={headOfficeAddress}
                        onValidationChange={updateHeadOfficeAddressValidity}
                    />
                }

                {
                    activeTab === "nouvelleAdresseSiegeSocial" &&
                    submissive &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== "raisonSociale" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }
                        {
                            activeTab === "nouvelleAdresseSiegeSocial" &&
                            <button type="submit"
                                onClick={handleNext}>
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }
                        {
                            activeTab !== "nouvelleAdresseSiegeSocial" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext}>
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive &&
                            activeTab === "nouvelleAdresseSiegeSocial" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }
                    </div>
                </div>
            </form>
        </>
    );
};

export default TransfertHorsDepartement;